import { signupStatus } from 'utils/constants';

export const signupInitialState = {
  data: null,
  status: '',
  instanceUrl: '',
  error: null,
};

export const signupReducer = (state, action) => {
  switch (action.type) {
    case 'SIGNUP_BEGIN':
      return {
        ...state,
        data: action.payload,
        status: signupStatus.started,
        error: null,
      };
    case 'SIGNUP_PENDING':
      return {
        ...state,
        status: signupStatus.pending,
        error: null,
      };
    case 'SIGNUP_ERROR':
      return {
        ...state,
        status: signupStatus.error,
        error: action.payload,
      };
    case 'SIGNUP_COMPLETE':
      return {
        ...state,
        status: signupStatus.complete,
        instanceUrl: action.payload,
        error: null,
      };
    default:
      return state;
  }
};
